import { render } from "./AddWorkspaceModal.vue?vue&type=template&id=b5612ed4&scoped=true&ts=true"
import script from "./AddWorkspaceModal.vue?vue&type=script&lang=ts"
export * from "./AddWorkspaceModal.vue?vue&type=script&lang=ts"

import "./AddWorkspaceModal.vue?vue&type=style&index=0&id=b5612ed4&lang=scss&scoped=true"
import "./AddWorkspaceModal.vue?vue&type=style&index=1&id=b5612ed4&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5612ed4"]])

export default __exports__